import { PRODUCTION_VARIANT } from "../shared/controleVariants";
import { CONTROLE_BIS_DOSSIER_TYPE, emptySection } from "../shared/controleConstants";
import { formatDate, todayISO } from "../shared/controleFormat";
import { patientControlsForDossier } from "../shared/patientControlRules";

export function addDaysISO(date, days) {
    const parsed = date ? new Date(`${date}T00:00:00`) : new Date();
    parsed.setDate(parsed.getDate() + days);
    return parsed.toISOString().slice(0, 10);
}

export function hasText(value) {
    return String(value || "").trim().length > 0;
}

export function hasAnyText(values) {
    return values.some(hasText);
}

export function hasRows(rows) {
    return Array.isArray(rows) && rows.length > 0;
}

export function defaultFormData() {
    return {
        meta: {
            pharmacien: "",
            lancementHeure: "",
            nombreSachetsProduits: "",
            tempsProduction: "",
            nombrePatients: "",
            patientControle: "",
            preProductionValidatedAt: "",
            preProductionValidatedBy: "",
            ehpad: "",
            dateEdition: todayISO(),
            dateLotDebut: todayISO(),
            dateLotFin: addDaysISO(todayISO(), 7),
            numeroControlePharmacie: "",
        },
        productionRobot: {
            producteurRobot: "",
            residentsActifsPDose: "",
            residentsProduitsRobot: "",
            residentsLivresDDose: "",
        },
        conditionsProduction: {
            heureDebut: "",
            heureFin: "",
            temperature: "",
            hygrometrie: "",
        },
        residents: [],
        incidents: { problemes: "", details: "" },
        controlesQualite: [],
        controlesQualiteMeta: { rouleauxCyclamed: "" },
        reparationControleFinal: {
            realisePar: "",
            controlePi: "",
            pontageRouleaux: "",
            dateHeure: "",
        },
        liberationLotProduction: {
            pharmacien: "",
            date: "",
            heure: "",
            signatureCachet: "",
        },
        commentaires: {},
        controlePatients: {},
        remarquesPoint1: [],
        ...Object.fromEntries(PRODUCTION_VARIANT.sections.map(section => [section.key, emptySection(section)])),
    };
}

export function mergeFormData(data) {
    return {
        ...defaultFormData(),
        ...(data || {}),
        meta: { ...defaultFormData().meta, ...(data?.meta || {}) },
        productionRobot: { ...defaultFormData().productionRobot, ...(data?.productionRobot || {}) },
        conditionsProduction: { ...defaultFormData().conditionsProduction, ...(data?.conditionsProduction || {}) },
        residents: Array.isArray(data?.residents) ? data.residents : [],
        incidents: { ...defaultFormData().incidents, ...(data?.incidents || {}) },
        controlesQualite: Array.isArray(data?.controlesQualite) ? data.controlesQualite : [],
        controlesQualiteMeta: { ...defaultFormData().controlesQualiteMeta, ...(data?.controlesQualiteMeta || {}) },
        reparationControleFinal: { ...defaultFormData().reparationControleFinal, ...(data?.reparationControleFinal || {}) },
        liberationLotProduction: { ...defaultFormData().liberationLotProduction, ...(data?.liberationLotProduction || data?.liberationLotProductionPda || {}) },
        commentaires: { ...(data?.commentaires || {}) },
        controlePatients: { ...(data?.controlePatients || {}) },
        remarquesPoint1: Array.isArray(data?.remarquesPoint1) ? data.remarquesPoint1 : [],
    };
}

export function latestPatientControlDossier(dossiers, activeDossier, patientId, ehpadId) {
    return [...(dossiers || [])]
        .filter(dossier => dossier?.donnees?.meta?.dossierType === CONTROLE_BIS_DOSSIER_TYPE)
        .filter(dossier => !activeDossier?.id || String(dossier.id) !== String(activeDossier.id))
        .filter(dossier => !activeDossier?.dateProduction || String(dossier.dateProduction || "") < String(activeDossier.dateProduction))
        .filter(dossier => !ehpadId || String(dossier.ehpadId) === String(ehpadId))
        .filter(dossier => patientControlsForDossier(dossier, patientId))
        .sort((a, b) => String(b.dateProduction || "").localeCompare(String(a.dateProduction || ""))
            || String(b.updatedAt || "").localeCompare(String(a.updatedAt || ""))
            || (Number(b.id) || 0) - (Number(a.id) || 0))[0] || null;
}

export function dossierLabel(dossier) {
    return `${dossier?.numeroLot || "—"} · ${formatDate(dossier?.dateProduction)}`;
}
